import { getMenuCoursingTypesTranslation } from './chunk-VQRUMOGW.mjs';
import { getTaxesDiffArrayCore } from './chunk-X6IVGVL4.mjs';
import { selectOriginalMenuData, selectMenu, selectCurrentItem } from './chunk-RO5AAHK3.mjs';
import { i18n_config_default } from './chunk-5FPUWZMY.mjs';
import { __spreadValues } from './chunk-T36PI2YV.mjs';
import difference from 'lodash/difference';

var MenuTypeMasterFieldLabels = /* @__PURE__ */ ((MenuTypeMasterFieldLabels2) => {
  MenuTypeMasterFieldLabels2[MenuTypeMasterFieldLabels2["name"] = 0] = "name";
  MenuTypeMasterFieldLabels2[MenuTypeMasterFieldLabels2["itemIds"] = 1] = "itemIds";
  MenuTypeMasterFieldLabels2[MenuTypeMasterFieldLabels2["comboIds"] = 2] = "comboIds";
  MenuTypeMasterFieldLabels2[MenuTypeMasterFieldLabels2["categoryIds"] = 3] = "categoryIds";
  return MenuTypeMasterFieldLabels2;
})(MenuTypeMasterFieldLabels || {});
var MenuTypeBasicSectionFieldLabels = /* @__PURE__ */ ((MenuTypeBasicSectionFieldLabels2) => {
  MenuTypeBasicSectionFieldLabels2[MenuTypeBasicSectionFieldLabels2["posName"] = 0] = "posName";
  MenuTypeBasicSectionFieldLabels2[MenuTypeBasicSectionFieldLabels2["active"] = 1] = "active";
  MenuTypeBasicSectionFieldLabels2[MenuTypeBasicSectionFieldLabels2["enableSimpleMode"] = 2] = "enableSimpleMode";
  MenuTypeBasicSectionFieldLabels2[MenuTypeBasicSectionFieldLabels2["comboDisplayName"] = 3] = "comboDisplayName";
  MenuTypeBasicSectionFieldLabels2[MenuTypeBasicSectionFieldLabels2["coursingType"] = 4] = "coursingType";
  MenuTypeBasicSectionFieldLabels2[MenuTypeBasicSectionFieldLabels2["defaultToHomeScreen"] = 5] = "defaultToHomeScreen";
  return MenuTypeBasicSectionFieldLabels2;
})(MenuTypeBasicSectionFieldLabels || {});
var MenuTypeMoreInformationFieldLabels = /* @__PURE__ */ ((MenuTypeMoreInformationFieldLabels2) => {
  MenuTypeMoreInformationFieldLabels2[MenuTypeMoreInformationFieldLabels2["description"] = 0] = "description";
  return MenuTypeMoreInformationFieldLabels2;
})(MenuTypeMoreInformationFieldLabels || {});
var menuTypeIgnoredQuantitySizeFields = ["defaultQuantitySelected"];
var returnLabel = (field) => {
  if (field in MenuTypeMasterFieldLabels) {
    return i18n_config_default.t(
      `app.modals.menuTypesDiffModal.master.${field}`
    );
  }
  if (field in MenuTypeBasicSectionFieldLabels) {
    return i18n_config_default.t(
      `app.modals.menuTypesDiffModal.basic.${field}`
    );
  }
  if (field in MenuTypeMoreInformationFieldLabels) {
    return i18n_config_default.t(
      `app.modals.menuTypesDiffModal.moreInfo.${field}`
    );
  }
};
var diffMenuTypesFactory = (menuTypeId, diffArray, currentMenu, menuTypeData, state) => {
  if (diffArray.length > 0) {
    const originalData = selectOriginalMenuData(state);
    const menuTypeItemIds = originalData.itemIds;
    const menuTypeComboIds = originalData.comboIds;
    const menuTypeCategoryIds = originalData.categoryIds;
    const currentItemIds = menuTypeData.itemIds;
    const currentComboIds = menuTypeData.comboIds;
    const currentCategoryIds = menuTypeData.categoryIds;
    const templateItemIds = menuTypeData.itemMenuTypeTemplateIds;
    const templateComboIds = menuTypeData.comboMenuTypeTemplateIds;
    const items = currentMenu.items;
    const combos = currentMenu.combos;
    const categories = currentMenu.categories;
    const formattedDiffArray = diffArray.filter(
      (diff) => diff.path.length === 1 && diff.path[0] !== "itemIds" && diff.path[0] !== "comboIds" && diff.path[0] !== "categoryIds"
    ).map((diff) => {
      var _a, _b, _c;
      if (!diff.path)
        return { field: null };
      const field = diff.path[((_a = diff.path) == null ? void 0 : _a.length) - 1];
      return {
        field,
        label: (_b = returnLabel(field)) != null ? _b : "",
        value: (_c = diff.rhs) != null ? _c : ""
      };
    });
    const hasSomeItemIds = diffArray.filter(
      (diff) => diff.path[0] === "itemIds"
    ).length;
    const hasSomeCategoryIds = diffArray.filter(
      (diff) => diff.path[0] === "categoryIds"
    ).length;
    const hasSomeComboIds = diffArray.filter(
      (diff) => diff.path[0] === "comboIds"
    ).length;
    const itemValues = getMenuTypesItemsChanges(
      Boolean(hasSomeItemIds),
      menuTypeItemIds,
      currentItemIds,
      items,
      templateItemIds
    );
    const comboValues = getMenuTypesCombosChanges(
      Boolean(hasSomeComboIds),
      menuTypeComboIds,
      currentComboIds,
      combos,
      templateComboIds
    );
    const categoryValues = getCategoriesChanges(
      Boolean(hasSomeCategoryIds),
      menuTypeCategoryIds,
      currentCategoryIds,
      categories
    );
    const itemsChanges = {
      field: "itemIds",
      label: returnLabel("itemIds"),
      value: itemValues
    };
    const categoriesChanges = {
      field: "categoryIds",
      label: returnLabel("categoryIds"),
      value: categoryValues
    };
    const combosChanges = {
      field: "comboIds",
      label: returnLabel("comboIds"),
      value: comboValues
    };
    const associationsItems = [];
    const associationsCategories = [];
    const associationsCombos = [];
    if (itemValues.length > 0) {
      associationsItems.push(itemsChanges);
    }
    if (itemValues.length > 0) {
      associationsCategories.push(categoriesChanges);
    }
    if (comboValues.length > 0) {
      associationsCombos.push(combosChanges);
    }
    const { masterChanges, basicChanges, moreInformationChanges } = filterChangesBySection(formattedDiffArray);
    basicChanges == null ? void 0 : basicChanges.forEach((change) => {
      if (change.field === "coursingType") {
        change.textValue = getMenuCoursingTypesTranslation(
          change.value
        );
      }
    });
    return {
      menuTypeId,
      masterChanges,
      basic: basicChanges,
      moreInfo: moreInformationChanges,
      associations: {
        items: associationsItems,
        categories: associationsCategories,
        combos: associationsCombos,
        taxes: getTaxesDiffArrayCore(
          originalData.taxIds,
          menuTypeData.taxIds,
          state
        )
      }
    };
  }
  return null;
};
var filterChangesBySection = (formattedDiffArray) => {
  const masterChanges = formattedDiffArray.filter(
    (diff) => diff.field ? Object.keys(MenuTypeMasterFieldLabels).filter((value) => isNaN(Number(value))).includes(diff.field) : false
  );
  const basicChanges = formattedDiffArray.filter(
    (diff) => diff.field ? Object.keys(MenuTypeBasicSectionFieldLabels).filter((value) => isNaN(Number(value))).includes(diff.field) : false
  );
  const moreInformationChanges = formattedDiffArray.filter(
    (diff) => diff.field ? Object.keys(MenuTypeMoreInformationFieldLabels).filter((value) => isNaN(Number(value))).includes(diff.field) : false
  );
  return {
    masterChanges,
    basicChanges,
    moreInformationChanges
  };
};
var getItemsCombosAndCategoriesChanges = (hasSomeCategoryIds, hasSomeItemIds, hasSomeComboIds, state) => {
  const currentMenu = selectMenu(state);
  const menuType = selectOriginalMenuData(state);
  const menuTypeItemIds = menuType.itemIds;
  const menuTypeComboIds = menuType.comboIds;
  const menuTypeCategoryIds = menuType.categoryIds;
  const currentMenuType = selectCurrentItem(state);
  const itemIds = currentMenuType.itemIds;
  const comboIds = currentMenuType.comboIds;
  const categoryIds = currentMenuType.categoryIds;
  const items = currentMenu.items;
  const combos = currentMenu.combos;
  const categories = currentMenu.categories;
  return {
    itemsChanges: getMenuTypesItemsChanges(
      hasSomeItemIds,
      menuTypeItemIds,
      itemIds,
      items
    ),
    combosChanges: getMenuTypesCombosChanges(
      hasSomeComboIds,
      menuTypeComboIds,
      comboIds,
      combos
    ),
    categoriesChanges: getCategoriesChanges(
      hasSomeCategoryIds,
      menuTypeCategoryIds,
      categoryIds,
      categories
    )
  };
};
var getMenuTypesItemsChanges = (hasSomeItemIds, bucketItemIds, itemIds, items, templateIds) => {
  const itemsValues = [];
  if (hasSomeItemIds) {
    const removedItemIds = difference(bucketItemIds, itemIds);
    const addedItemIds = difference(itemIds, bucketItemIds);
    if (removedItemIds.length > 0) {
      removedItemIds.map((removedItemId) => {
        const itemName = items ? items[removedItemId].name : "";
        itemsValues.push({
          action: "remove",
          id: removedItemId,
          value: itemName
        });
      });
    }
    if (addedItemIds.length > 0) {
      addedItemIds.map((addedItemId) => {
        const itemName = items ? items[addedItemId].name : "";
        itemsValues.push(__spreadValues({
          action: "add",
          id: addedItemId,
          value: itemName
        }, templateIds && {
          menuTypeTemplateId: templateIds[addedItemId]
        }));
      });
    }
  }
  return itemsValues;
};
var getMenuTypesCombosChanges = (hasSomeItemIds, bucketComboIds, comboIds, combos, templateIds) => {
  const combosValues = [];
  if (hasSomeItemIds) {
    const removedComboIds = difference(bucketComboIds, comboIds);
    const addedComboIds = difference(comboIds, bucketComboIds);
    if (removedComboIds.length > 0) {
      removedComboIds.map((removedComboId) => {
        const comboName = combos ? combos[removedComboId].name : "";
        combosValues.push({
          action: "remove",
          id: removedComboId,
          value: comboName
        });
      });
    }
    if (addedComboIds.length > 0) {
      addedComboIds.map((addedComoId) => {
        const comboName = combos ? combos[addedComoId].name : "";
        combosValues.push(__spreadValues({
          action: "add",
          id: addedComoId,
          value: comboName
        }, templateIds && {
          menuTypeTemplateId: templateIds[addedComoId]
        }));
      });
    }
  }
  return combosValues;
};
var getCategoriesChanges = (hasSomeCategoryIds, bucketCategoryIds, categoryIds, categories) => {
  const categoriesValues = [];
  if (hasSomeCategoryIds) {
    const removedCategoryIds = difference(
      bucketCategoryIds,
      categoryIds
    );
    const addedCategoryIds = difference(
      categoryIds,
      bucketCategoryIds
    );
    if (removedCategoryIds.length > 0) {
      removedCategoryIds.map((removedCategoryId) => {
        const itemName = categories[removedCategoryId].name;
        categoriesValues.push({
          action: "remove",
          id: removedCategoryId,
          value: itemName
        });
      });
    }
    if (addedCategoryIds.length > 0) {
      addedCategoryIds.map((addedCategoryId) => {
        const itemName = categories[addedCategoryId].name;
        categoriesValues.push({
          action: "add",
          id: addedCategoryId,
          value: itemName
        });
      });
    }
  }
  return categoriesValues;
};

export { MenuTypeBasicSectionFieldLabels, MenuTypeMasterFieldLabels, MenuTypeMoreInformationFieldLabels, diffMenuTypesFactory, getCategoriesChanges, getItemsCombosAndCategoriesChanges, getMenuTypesCombosChanges, getMenuTypesItemsChanges, menuTypeIgnoredQuantitySizeFields };
